import React from 'react'
import '../styles/pageStyles/Profile.scss'

import ChannelInfo from '../components/Profile/ChannelInfo'

const Profile = () => {
    return (
        <div className='profile'>
            <ChannelInfo />
        </div>
    )
}

export default Profile